import { useSearchParams } from 'react-router-dom';
import { Monitor, BarChart3 } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { SkuImportFlow } from '@/components/import/sku-import-flow';
import { SalesImportFlow } from '@/components/import/sales-import-flow';

type TabValue = 'skus' | 'sales';

export default function AdminImportRoute() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab: TabValue = tabParam === 'sales' ? 'sales' : 'skus';

  const handleTabChange = (value: string) => {
    const next = new URLSearchParams(searchParams);
    if (value === 'skus') next.delete('tab');
    else next.set('tab', value);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="mx-auto max-w-6xl space-y-6 p-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-bold tracking-tight">Import dữ liệu CSV</h1>
        <p className="text-sm text-muted-foreground">
          Upload file CSV để cập nhật SKUs hoặc dữ liệu sales hàng tháng. Hệ thống preview thay đổi trước khi áp dụng.
        </p>
      </header>

      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="skus">
            <Monitor />
            SKUs (báo giá)
          </TabsTrigger>
          <TabsTrigger value="sales">
            <BarChart3 />
            Sales theo tháng
          </TabsTrigger>
        </TabsList>

        <TabsContent value="skus">
          <SkuImportFlow />
        </TabsContent>

        <TabsContent value="sales">
          <SalesImportFlow />
        </TabsContent>
      </Tabs>
    </div>
  );
}
